module.exports = __webpack_public_path__ + "img/图片1.14079bde.png";